import React, {Component} from 'react'
import './Layout/HorseLoading.css'

class HorseLoading extends Component {
  render () {
    return (
      <div className="horse-loading">
        <span />
      </div>
    )
  }
}

export default HorseLoading



// WEBPACK FOOTER //
// ./src/components/Common/HorseLoading/HorseLoading.js